// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hwpWy","title":"Header_title__JjZoC","side":"Header_side__3Ib03"};